<template>
  <div class="inquiry-tool">
    <div class="tab">
      <div class="tab-item" :class="currentTab == v.key?'act':''" v-for="(v,i) in tabList" :key="i" @click="tabFun(v)">
        <div class="title">{{ v.title }}</div>
        <div class="line"></div>
      </div>
    </div>
    <div class="content-wrapper">
      <div class="form-content">
        <el-form
            ref="form"
            size="large"
            :model="form"
            :rules="rules"
            label-width="170px"
        >
          <el-form-item :label="currentLabel" prop="keyword">
            <el-input
                clearable
                v-model="form.keyword"
                :placeholder="currentPlaceholder"
            />
          </el-form-item>
          <el-form-item label="验证码:" prop="code">
            <div class="input-group">
              <el-input
                  clearable
                  v-model="form.code"
                  placeholder="请输入验证码"
              />
              <img
                  alt=""
                  v-if="captcha"
                  :src="captcha"
                  class="captcha"
                  @click="changeCaptcha"
              />
            </div>
          </el-form-item>
          <el-form-item class="btn-item">
            <el-button
                type="primary"
                class="login-btn"
                :loading="loading"
                @click="submit"
            >
              {{ loading ? '查询中...' : '立即提交' }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="result-content" v-if="showResult">
        <el-image style="margin: 0 160px" v-if="resultData.length < 1" class="rc-no"
                  :src="resultEmpty"></el-image>
        <div class="rc-yes" v-else>
          <div class="rcy-item" v-for="(v,i) in resultData" :key="i">
            <inquiry-result-table :data="v" :sign="sign" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InquiryResultTable from "./ResultTable.vue";

export default {
  name: "InquiryTool",
  components: {InquiryResultTable},
  data() {
    return {
      tabList: [
        {
          title: '校准/检定证书查询',
          key: 1
        },
        {
          title: '检验检测/校验报告查询',
          key: 2
        },
        {
          title: '认证/证书查询',
          key: 3
        },
        {
          title: '荣誉证书查询',
          key: 4
        },
        {
          title: '产品真假防伪查询',
          key: 5
        }
      ],
      currentTab: 1,
      form: {
        keyword: '',
        code: '',
        codeKey: ''
      },
      loading: false,
      // 验证码base64数据
      captcha: '',
      resultData: [],
      showResult: false,
      resultEmpty: '',
      sign: null
    }
  },
  computed: {
    rules() {
      let temp = {
        code: [
          {
            required: true,
            message: '请输入验证码',
            type: 'string',
            trigger: 'blur'
          }
        ]
      }
      if (this.currentTab == 1) {
        temp = Object.assign(temp, {
          keyword: [
            {
              required: true,
              message: '请输入证书编号',
              type: 'string',
              trigger: 'blur'
            }
          ]
        })
      } else if (this.currentTab == 2) {
        temp = Object.assign(temp, {
          keyword: [
            {
              required: true,
              message: '请输入报告编号',
              type: 'string',
              trigger: 'blur'
            }
          ]
        })
      } else if (this.currentTab == 3 || this.currentTab == 4) {
        temp = Object.assign(temp, {
          keyword: [
            {
              required: true,
              message: '请输入证书编号或单位名称',
              type: 'string',
              trigger: 'blur'
            }
          ]
        })
      } else {
        temp = Object.assign(temp, {
          keyword: [
            {
              required: true,
              message: '请输入防伪码',
              type: 'string',
              trigger: 'blur'
            }
          ]
        })
      }
      return temp
    },
    currentLabel() {
      let temp = ''
      if (this.currentTab == 1) {
        temp = '证书编号'
      } else if (this.currentTab == 2) {
        temp = '报告编号'
      } else if (this.currentTab == 3 || this.currentTab == 4) {
        temp = '证书编号/单位名称'
      } else {
        temp = '防伪码'
      }
      return temp
    },
    currentPlaceholder() {
      let temp = ''
      if (this.currentTab == 1) {
        temp = '请输入证书编号，多个编号请用英文逗号分隔'
      } else if (this.currentTab == 2) {
        temp = '请输入报告编号，多个编号请用英文逗号分隔'
      } else if (this.currentTab == 3 || this.currentTab == 4) {
        temp = '请输入证书编号或单位名称，多个编号请用英文逗号分隔'
      } else {
        temp = '请输入防伪码，多个防伪码请用英文逗号分隔'
      }
      return temp
    }
  },
  created() {
    this.$nextTick(() => {
      this.changeCaptcha();
      if (Object.keys(this.$route.params).length > 0) {
        const {keyword, code, codeKey, currentTab} = this.$route.params
        this.form = {
          keyword,
          code,
          codeKey
        }
        this.currentTab = currentTab
        this.submitQuery()
      }
    })
  },
  methods: {
    /* 更换图形验证码 */
    changeCaptcha() {
      this.$request.get('/Inquiry/captcha')
          .then(res => {
            if (res.code === 0) {
              this.captcha = res.data.base64;
              this.form.codeKey = res.data.codeKey;
              if(this.$refs.form){
                this.$refs.form.clearValidate();
              }
            }
          })
    },
    /**
     * 立即提交
     */
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false;
        }
        if (['/', '/home'].indexOf(this.$route.path) !== -1) {
          this.$router.push({
            name: 'Inquiry', params: {
              ...this.form,
              currentTab: this.currentTab
            }
          })
        } else {
          this.submitQuery()
        }
      })
    },
    /**
     * 查询接口
     */
    submitQuery() {
      this.loading = true;
      this.$request.post('/Inquiry/submitQuery', {
        ...this.form,
        classifyId: this.currentTab
      })
          .then(res => {
            if (res.code === 0) {
              this.showResult = true
              this.resultData = res.data.list
              this.resultEmpty = res.data.empty
              this.sign = res.data.sign
            }
            this.form.code = ''
            this.loading = false
            this.changeCaptcha()
          })
          .catch(e => {
            this.form.code = ''
            this.loading = false
            this.changeCaptcha()
          })
    },
    /**
     * tab选择
     * @param key
     */
    tabFun({key}) {
      this.currentTab = key
      this.resultData = []
      this.showResult = false
    }
  }
}
</script>

<style scoped lang="scss">
.inquiry-tool {
  width: 100%;
  background-color: #FFFFFF;
  border-radius: 8px;

  .content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;

    .form-content {
      padding: 45px 0 30px 0;
      width: 66%;

      .input-group {
        display: flex;
        align-items: center;

        :deep(.el-input) {
          flex: 1;
        }

        .captcha {
          height: 50px;
          width: 210px;
          margin-left: 10px;
          border-radius: 4px;
          border: 1px solid #dcdfe6;
          text-align: center;
          cursor: pointer;
        }
      }

      ::v-deep {
        .btn-item .el-form-item__content {
          margin-left: 0 !important;
          text-align: center;
        }

        .el-form-item__content {
          height: 50px;
        }
        .el-form-item__label,
        .el-input__inner {
          height: 50px;
          line-height: 50px;
          font-size: 17px;
        }
      }

      .el-button {
        background-color: #1464FF;
        width: 150px;
      }
    }

    .result-content {
      width: 90%;
      padding-bottom: 45px;

      .rcy-item {
        position: relative;

        .sign {
          position: absolute;
          right: 20px;
          bottom: 20px;
          width: 40px;
          height: 40px;
        }
      }
    }
  }

  .tab {
    width: 100%;
    height: 56px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #D7D7D7;
    position: relative;

    .tab-item {
      width: calc(100% / 5);
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      color: #6C6C6C;
      font-size: 20px;

      &.act {
        color: #2D2D2D;
        font-weight: bold;

        .line {
          display: block;
        }
      }

      .line {
        position: absolute;
        background-color: #0065f6;
        width: 76px;
        height: 4px;
        border-radius: 10px;
        bottom: 0;
        display: none;
      }
    }
  }
}
</style>